/**
 * 权限相关
 */
import isEmpty from 'lodash/isEmpty'
import isArray from 'lodash/isArray'

/**
 * 获取菜单、按钮
 * @param tree
 * @param data
 * @returns
 */
const getMenuAndButton = (tree: any[], data?: any) => {
  return tree.reduce(
    (prev, next) => {
      const { menuPermissionList, buttonPermissionList, ...rest } = next
      if (isArray(menuPermissionList) && !isEmpty(menuPermissionList)) {
        const result = getMenuAndButton(menuPermissionList, prev)
        return {
          menus: [rest].concat(result.menus),
          buttons: result.buttons,
        }
      }
      return {
        menus: prev.menus.concat([rest]),
        buttons: prev.buttons.concat(buttonPermissionList || []),
      }
    },
    data || {
      menus: [],
      buttons: [],
    },
  )
}

// 获取菜单、按钮
// const getMenuAndButton = (tree: any) => {
//   const obj = {
//     menus: [], // 包含一级、二级
//     buttons: [],
//   }
//   loopTree(tree, 'menu', obj)
//   return obj
// }

// const loopTree = (list: any, type: string, obj?: any) => {
//   list.forEach((item: any) => {
//     if (isArray(item.menuPermissionList) && !isEmpty(item.menuPermissionList)) {
//       loopTree(item.menuPermissionList, 'menu', obj)
//     }
//     if (isArray(item.buttonPermissionList) && !isEmpty(item.buttonPermissionList)) {
//       loopTree(item.buttonPermissionList, 'button', obj)
//     }

//     if (type === 'menu') {
//       if (!obj.menus.map(m => m.code).includes(item.code)) {
//         obj.menus.push(item)
//       }
//     } else {
//       if (!obj.buttons.map(b => b.code).includes(item.code)) {
//         obj.buttons.push(item)
//       }
//     }
//   })
// }

export { getMenuAndButton }
